export default "/_next/static/images/footerbanner-mobile-e0ba85f362e7678beda6008db69420c2.png";